var _line, _line2, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.1,
    y1: 5.4,
    x2: 8.9,
    y2: 5.4,
    stroke: "#404040",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.1,
    y1: 7.4,
    x2: 9.9,
    y2: 7.4,
    stroke: "#404040",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.25C3.98122 1.25 2.75 2.48122 2.75 4V20C2.75 21.5188 3.98122 22.75 5.5 22.75H10.5V21.25H5.5C4.80964 21.25 4.25 20.6904 4.25 20V4C4.25 3.30964 4.80964 2.75 5.5 2.75H17.5C18.1904 2.75 18.75 3.30964 18.75 4V11H20.25V4C20.25 2.48122 19.0188 1.25 17.5 1.25H5.5Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7222 23.0003C13.7222 20.2776 14.2777 19.667 17.6111 19.667C20.9444 19.667 21.4999 20.2783 21.4999 23.0003",
    stroke: "#2B323B",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6112,
    cy: 15.7778,
    r: 2.12778,
    stroke: "#2B323B",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUser);
export default __webpack_public_path__ + "static/media/file-user.8a910c2448aae261604313dd136f2809.svg";
export { ForwardRef as ReactComponent };